<template>
  <controller>
    <page-header title="Negocie já" />
  </controller>
</template>

<script>
import PageHeader from '@/components/loja/template/PageHeader.vue'
export default {
  data () {
    return {
   
    PageHeader   
    }
  }
}
</script>

<style>

</style>